import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import { useCallback } from 'react';

export const useSetTradeFormPriceBox = () => {
	const setState = useVelocityStore((s) => s.set);

	const setTradeFormPriceBox = useCallback(
		(price: string) => {
			setState((state) => {
				// @ts-expect-error
				state.tradeForm.priceBoxStringValue = price;
			});
		},
		[setState]
	);

	return setTradeFormPriceBox;
};

export const useSetTradeFormBaseSize = () => {
	const setState = useVelocityStore((s) => s.set);

	const setTradeFormBaseSize = useCallback(
		(baseSize: string) => {
			setState((state) => {
				// @ts-expect-error
				state.tradeForm.baseSizeStringValue = baseSize;
			});
		},
		[setState]
	);

	return setTradeFormBaseSize;
};

export const useSetTradeFormQuoteSize = () => {
	const setState = useVelocityStore((s) => s.set);

	const setTradeFormQuoteSize = useCallback(
		(quoteSize: string) => {
			setState((state) => {
				// @ts-expect-error
				state.tradeForm.quoteSizeStringValue = quoteSize;
			});
		},
		[setState]
	);

	return setTradeFormQuoteSize;
};

export const useSetTradeFormSecondaryPriceBox = () => {
	const setState = useVelocityStore((s) => s.set);

	const setTradeFormSecondaryPriceBox = useCallback(
		(price: string) => {
			setState((state) => {
				// @ts-expect-error
				state.tradeForm.secondaryPriceBoxStringValue = price;
			});
		},
		[setState]
	);

	return setTradeFormSecondaryPriceBox;
};
